<b class="ml-2">
    <i class="fas fa-exclamation-circle {{relevancecolorclass}}"></i> 
    <ng-container *ngIf="showDesc"> {{relevanceDesc}}</ng-container></b>